import classNames from "classnames";
import * as React from "react";
import { Button, IconButton, Input, Label, MarkdownEditor, Modal, NotificationBlock } from "uxp/components";
import { parseValue } from "../../../../util";
import { IBaseProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import MarkdownView from "./MarkdownFieldView";
import './markdown.scss';
import { IContextProvider } from "../../../../uxp";
import { $L } from "../../../../localize";
interface IMarkdownFieldProperty extends IBaseProperty {
	text: string;
}

export const Field: React.FunctionComponent<IUIFieldProps<IMarkdownFieldProperty>> = (props) => {

	let text = props?.fieldProps?.text || '';

	return (
		<div className={classNames('ui-field', props.mode)} >
			<div className='widget-designer-field-markdown'>

			</div>
			<Label className="widget-designer-field-label">
				<MarkdownView text={text} />
			</Label>
		</div >
	)
}

interface IRichTextModalProps {
	uxpContext: IContextProvider,
	show: boolean,
	onClose: () => void,
	value: string,
	onChange: (v: string) => void
}

export const RichTextModal: React.FunctionComponent<IRichTextModalProps> = (props) => {
	const [draft, setDraft] = React.useState<string>(props.value || '');

	// re-seed the local draft each time the modal opens
	React.useEffect(() => {
		if (props.show) setDraft(props.value || '');
	}, [props.show]);

	return (
		<Modal
			className={'wd-rich-text-editor-modal'}
			show={props.show}
			onClose={props.onClose}
			showCloseButton={false}
			headerContent={
				<div className="wd-rich-text-editor-modal__header">
					<span className="wd-rich-text-editor-modal__title">
						{$L('widgetdesigner.props.rich-text-editor', 'Rich Text Editor')}
					</span>
					<div className="wd-rich-text-editor-modal__actions">
						<Button
							title={$L('widgetdesigner.props.save', 'Save')}
							variant="primary"
							onClick={() => {
								props.onChange(draft);
								props.onClose();
							}}
						/>
						<IconButton
							type="close"
							variant="secondary"
							size="small"
							onClick={props.onClose}
						/>
					</div>
				</div>
			}
		>
			<div className="content">
				<MarkdownEditor
					value={draft}
					onChange={setDraft}
					imageUploadPath={'canvas/uploads/'}
					fullWidth
					height={'100%'}
				/>
			</div>
		</Modal>
	)
}


interface IRichTextPropertyProps {
	uxpContext: IContextProvider,
	value: string,
	onChange: (v: string) => void
	title?: string,
	hideInputBox?: boolean
}


export const CommonRichTextProperty: React.FunctionComponent<IRichTextPropertyProps> = (props) => {
	const [showEditor, setShowEditor] = React.useState<boolean>(false)

	return <div className='wd-prop-item'>

		<RichTextModal
			show={showEditor}
			onClose={() => setShowEditor(false)}
			value={props.value || ''}
			onChange={props.onChange}
			uxpContext={props.uxpContext}
		/>

		<div className='wd-prop-item-title'>{props.title || 'Rich Text'}</div>
		<div className='wd-prop-item-editor'>
			{(() => {
				const lines = (props.value || '').split('\n').filter(Boolean).length;
				const linesText = lines > 0
					? $L('widgetdesigner.props.lines', '$count lines', { count: lines })
					: $L('widgetdesigner.props.empty', 'No content');
				return <NotificationBlock
					variant="info"
					mode="compact"
					layout="bordered"
					message={linesText}
					action={<Button
						title={$L('widgetdesigner.props.edit', 'Edit')}
						variant="secondary"
						icon="fal pen"
						iconPosition="right"
						onClick={() => { setShowEditor(true) }}
					/>}
				/>;
			})()}
		</div>

	</div>;
}


export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<IMarkdownFieldProperty>> = (props) => {
	const [showEditor, setShowEditor] = React.useState<boolean>(false)

	return (
		<CommonRichTextProperty
			value={props.uiProps.text || ''}
			onChange={v => props.onChange(Object.assign({}, props.uiProps, { text: v }))}
			uxpContext={props.uxpContext}
			title={'Rich Text'} />
	)

}

registerUIField({
	id: 'markdown',
	category: 'basic-text',
	description: 'Rich Text',
	field: Field,
	propertyEditor: PropertyEditor,
	defaultProps: {
		text: '# Rich Text\nGoes here\n![](https://static.iviva.com/lucy/logos/lucy-canvas-2.png)\n## Section 1\n* Item 1\n* Item 2\n* Item 3\n\n',
	},
	type: 'notes'
});

